/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DocumentForChat } from './DocumentForChat';
import {
    DocumentForChatFromJSON,
    DocumentForChatFromJSONTyped,
    DocumentForChatToJSON,
} from './DocumentForChat';

/**
 * 
 * @export
 * @interface DocumentChatResponse
 */
export interface DocumentChatResponse {
    /**
     * 
     * @type {Array<DocumentForChat>}
     * @memberof DocumentChatResponse
     */
    documents: Array<DocumentForChat>;
}

/**
 * Check if a given object implements the DocumentChatResponse interface.
 */
export function instanceOfDocumentChatResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "documents" in value;

    return isInstance;
}

export function DocumentChatResponseFromJSON(json: any): DocumentChatResponse {
    return DocumentChatResponseFromJSONTyped(json, false);
}

export function DocumentChatResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentChatResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documents': ((json['documents'] as Array<any>).map(DocumentForChatFromJSON)),
    };
}

export function DocumentChatResponseToJSON(value?: DocumentChatResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'documents': ((value.documents as Array<any>).map(DocumentForChatToJSON)),
    };
}

